import usePreferences from './usePreferences.main'

export default function useLoginState() {
  const {preferences} = usePreferences()

  const isLoggedIn = !!preferences?.user?.profile

  if (isLoggedIn) return 'loggedIn'

  if (preferences?.sessionPhone) return 'unauthenticatedSessionReady'

  if (!preferences?.sessionEmail) return 'loggedOut'

  if (preferences?.sessionEmailHasAccount) return 'unauthenticatedSessionStart'

  return 'newUser'
}
